import React from 'react';
import Magnifier from 'react-magnifier';

function MagnifierImage({ image, ...props }) {
  return <Magnifier zoomFactor={1} src={image} {...props} />;
}

export default MagnifierImage;
